import React, { createContext, useState } from "react";
import { AssessmentList } from "./AssessmentList";

interface ListContextValue {
  isallChecked: boolean;
  setIsallChecked: (loggedIn: boolean) => void;
}

export const listContext = createContext<ListContextValue>({
  isallChecked: false,
  setIsallChecked: () => {},
});

export const ListContext = () => {
  const [isallChecked, setIsallChecked] = useState(false);
  return (
    <listContext.Provider value={{ isallChecked, setIsallChecked }}>
      <AssessmentList />
    </listContext.Provider>
  );
};
